"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var AlertIcon = function AlertIcon() {
  return _react.default.createElement("svg", {
    width: "46px",
    height: "44px",
    viewBox: "0 0 46 44",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react.default.createElement("title", null, "EABE9A29-033A-4D6E-B3C6-3F2BF44CE9B4"), _react.default.createElement("desc", null, "Created with sketchtool."), _react.default.createElement("g", {
    id: "\uD83D\uDE80-Components",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    id: "Modal-Component",
    transform: "translate(-1619.000000, -634.000000)",
    fill: "#7C8292",
    fillRule: "nonzero"
  }, _react.default.createElement("path", {
    d: "M1665,655.989489 L1659.89818,650.145246 L1660.60909,642.408982 L1653.06091,640.685141 L1649.10909,634 L1642,637.069279 L1634.89091,634 L1630.93909,640.685141 L1623.39091,642.38796 L1624.10182,650.124224 L1619,655.989489 L1624.10182,661.833731 L1623.39091,669.591018 L1630.93909,671.314859 L1634.89091,678 L1642,674.909699 L1649.10909,677.978978 L1653.06091,671.293837 L1660.60909,669.569995 L1659.89818,661.833731 L1665,655.989489 Z M1644.09091,666.500717 L1639.90909,666.500717 L1639.90909,662.296226 L1644.09091,662.296226 L1644.09091,666.500717 Z M1644.09091,658.091734 L1639.90909,658.091734 L1639.90909,645.478261 L1644.09091,645.478261 L1644.09091,658.091734 Z",
    id: "Info-Alert-Icon"
  }))));
};

var _default = AlertIcon;
exports.default = _default;